<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:14:49
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-05-27 19:44:20
 * @Description: 统计数据卡片模块--今日
 -->
<template>
  <div class="observe-data">
    <div class="observe-data__card-container-1">
      <num-card :total="cloudView" danwei="景" name="今日上云" color="#F74C32" bgcolor="#FDF2F1"/>
      <num-card :total="cloudSize" danwei="T" name="今日上云" color="#7A73FF" bgcolor="#F1F0FD" />
      <num-card :total="pushView" danwei="景" name="今日推送" color="#29B7A3" bgcolor="#F7FFFE"/>
    </div>
    <div class="observe-data__card-container-2">
      <num-card :total="ydayCloudView" danwei="景" name="昨日上云" color="#45AAFB" bgcolor="#F7FDFF"/>
      <num-card :total="ydayCloudSize" danwei="T" name="昨日上云" color="#F78704" bgcolor="#FFF9F2"/>
      <num-card :total="ydayPushView" danwei="景" name="昨日推送" color="#EB4DDB" bgcolor="#FCF7FF"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NumCard from '@/components/num-card'

import {
  GET_STATISTICS,
} from '@/assets/const-value/interface'

/**
 * 设置 moment 的语言环境
 */
moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
export default {
  components: {
    NumCard,
  },
  data() {
    return {
      cloudView: 0,
      cloudSize: 0,
      pushView: 0,
      ydayCloudView: 0,
      ydayCloudSize: 0,
      ydayPushView: 0,
    }
  },
  created() {
    this.getStatistics()
  },
  methods: {
    /**
     * 获取覆盖率数据
     */
    async getStatistics() {
      const year = moment().year()
      // const periodType = 5 // day
      // const periodDay8 = 9 // day_8
      const periodDay = 5
      const period = moment().format('YYYYMMDD')
      const periodLast = moment().add(-1, 'days').format('YYYYMMDD')
      const satelliteGroupId19 = 19 // 可见光（8个卫星的组）
      const typeUpload = 1 // cloud
      const typePush = 3 // push
      const regionIdOrPushuser = '-' // 全球

      // 今日上云
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodDay, period, satelliteGroupId: satelliteGroupId19, type: typeUpload, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0) {
          if (res.data.children.length) {
            this.$emit('staEndTime', +res.data.children[0].lastModifyTime)
          } else {
            this.$emit('staEndTime', Date.now())
          }
          const cloudViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          const cloudSizeAdd = res.data.children.length ? res.data.children[0].sizeCurrent : 0
          this.cloudView = cloudViewAdd
          this.cloudSize = (cloudSizeAdd / 1024 / 1024 / 1024 / 1024).toFixed(2)
        }
      }).catch(err => console.error(err))

      // 昨日上云
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodDay, period: periodLast, satelliteGroupId: satelliteGroupId19, type: typeUpload, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0) {
          const cloudViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          const cloudSizeAdd = res.data.children.length ? res.data.children[0].sizeCurrent : 0
          this.ydayCloudView = cloudViewAdd
          this.ydayCloudSize = (cloudSizeAdd / 1024 / 1024 / 1024 / 1024).toFixed(2)
        }
      }).catch(err => console.error(err))

      // 今日推送
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodDay, period, satelliteGroupId: satelliteGroupId19, type: typePush, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0) {
          const pushViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          // const pushSizeAdd = res.data.children.length ? res.data.children[0].sizeCurrent : 0
          this.pushView = pushViewAdd
          // this.pushSize = (pushSizeAdd / 1024 / 1024 / 1024 / 1024).toFixed(2)
        }
      }).catch(err => console.error(err))

      // 昨日推送
      this.$axios.get(GET_STATISTICS({
        year, periodType: periodDay, period: periodLast, satelliteGroupId: satelliteGroupId19, type: typePush, regionIdOrPushuser,
      })).then((res) => {
        if (res.code === 0) {
          const pushViewAdd = res.data.children.length ? res.data.children[0].numCurrent : 0
          this.ydayPushView = pushViewAdd
        }
      }).catch(err => console.error(err))
    },
  },
}
</script>
